import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Loader2 } from 'lucide-react';
import { useBlogPosts } from '../../hooks/useBlogPosts';
import BlogPostCard from './BlogPostCard';

export default function FeaturedPosts() {
  const { posts, loading, error } = useBlogPosts(3);

  if (loading) {
    return (
      <div className="flex justify-center py-8">
        <Loader2 className="h-8 w-8 animate-spin text-primary-500" />
      </div>
    );
  }

  if (error || posts.length === 0) {
    return null;
  }

  return (
    <div className="py-4 bg-white blog-section">
      <div className="container mx-auto px-4">
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-2xl font-bold">Featured Articles</h2>
          <Link 
            to="/blog" 
            className="text-primary-600 hover:text-primary-700 flex items-center gap-2"
          >
            View All Articles
            <ArrowRight className="h-4 w-4" />
          </Link>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {posts.map(post => (
            <BlogPostCard key={post.id} post={post} />
          ))}
        </div>
      </div>
    </div>
  );
}